// material-ui
import {CssBaseline, Box, Tooltip, Stack} from '@mui/material';
import {useTheme} from '@mui/material/styles';
import navIcon from 'assets/images/icons/NavIconShortcut.svg';
import bookIcon from 'assets/images/icons/BookIconShortcut.svg';
import guideIcon from 'assets/images/icons/GuideIconShortcut.svg';

type SidebarToggleProps = {
  trigger: (source: string) => void;
  navigatorVisible?: boolean | undefined;
  legendVisible?: boolean | undefined;
  aiGuideVisible?: boolean | undefined;
};

const NavigatorToggle = ({
  trigger,
  navigatorVisible = true,
  legendVisible = true,
  aiGuideVisible = false,
}: SidebarToggleProps): JSX.Element => {
  const theme = useTheme();

  return (
    <>
      <CssBaseline />
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '4px',
          height: '100%',
          top: '90%',
          position: 'fixed',
          right: '25px',
          zIndex: theme.zIndex.speedDial,
        }}
      >
        {(navigatorVisible || legendVisible || aiGuideVisible) && (
          <Box
            sx={{
              zIndex: theme.zIndex.speedDial,
              background: theme.palette.primary.main,
              borderRadius: '30px',
              px: 1,
              pt: 1,
              pb: 0.5,
            }}
          >
            <Stack direction='column' alignItems='center' justifyContent='center'>
              {aiGuideVisible && (
                <Box py={0.4}>
                  <Tooltip arrow title='AI Ascend' placement='left'>
                    <img width={28} height={28} color={'white'} src={guideIcon} alt='Guide' />
                  </Tooltip>
                </Box>
              )}
              {legendVisible && (
                <Box onClick={() => trigger('legend')}>
                  <Tooltip arrow title='Abbreviation Key' placement='left'>
                    <img width={28} height={28} color={'white'} src={bookIcon} alt='Legend' />
                  </Tooltip>
                </Box>
              )}
              {navigatorVisible && (
                <Box onClick={() => trigger('navigator')}>
                  <Tooltip arrow title='Navigator' placement='left'>
                    <img width={30} height={30} color={'white'} src={navIcon} alt='Navigator' />
                  </Tooltip>
                </Box>
              )}
            </Stack>
          </Box>
        )}
      </Box>
    </>
  );
};

export default NavigatorToggle;
